module.exports = __webpack_public_path__ + "img/voto_h2.468ae426.png";